import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { useRootStore } from '../../../../providers/root-store-provider';
import { Alert } from '../../../app/alert/alert';
import { Button } from '../../../app/form/button/button';
import { routes } from '../../../../config/routes';
import { BaseDialog } from '../../../app/dialogs/base-dialog';

export const AlreadyLoggedInDialog: React.FC = observer(() => {
    const { t } = useTranslation();
    const { authDialogStore } = useRootStore().authStore;
    const router = useRouter();

    return (
        <BaseDialog
            opened={authDialogStore.activeModal === 'alreadyLoggedIn'}
            close={() => authDialogStore.closeDialog()}
            title={t('dialogs.alreadyLoggedIn.title')}
            content={<Alert type="info">{t('dialogs.alreadyLoggedIn.message')}</Alert>}
            action={
                <>
                    <Button
                        variant="negative"
                        variation="outlined"
                        size="medium"
                        type="button"
                        onClick={async () => {
                            authDialogStore.closeDialog();
                            await router.push(routes.web.indexLogout);
                        }}
                    >
                        {t('dialogs.alreadyLoggedIn.button.logout')}
                    </Button>
                    <Button
                        variant="primary"
                        size="medium"
                        type="button"
                        onClick={async () => {
                            authDialogStore.closeDialog();
                            await router.push(routes.app.index);
                        }}
                    >
                        {t('dialogs.alreadyLoggedIn.button.goToApp')}
                    </Button>
                </>
            }
        />
    );
});
